import React from 'react';
import GenericDropdown from 'components/GenericDropdown';
import TextButton from 'components/TextButton';
import HamburgerIcon from 'resources/icon-hamburger-main-menu.svg';
import IconClose from 'resources/icon-main-menu-close.svg';
import './MainMenuDropdown.css';

function MainMenuDropdown({ mobile, children, onToggle, ...rest }) {
  const className = `main-menu${mobile ? ' main-menu-mobile' : ''}`;
  const icon = <img src={HamburgerIcon} alt="Main Menu" />;

  const closeButton = (
    <div className="main-menu-close-icon">
      <TextButton onClick={() => onToggle(false)}>
        <img src={IconClose} alt="Close Menu" />
      </TextButton>
    </div>
  );

  return (
    <GenericDropdown
      className={className}
      dropdownId="main-menu-dropdown"
      format="filled"
      title={icon}
      mobile={mobile}
      rightAlign
      onToggle={onToggle}
      {...rest}
    >
      {closeButton}
      {children}
    </GenericDropdown>
  );
}

export default MainMenuDropdown;
